import React from 'react';
import { get, find, merge } from 'lodash';

// React view component to render
import { cSrOrderListNotes as CSrOrderListNotesView } from 'ui/views/widgets/cSROrderListNotes';
import { OrderLineItemNotesService } from 'services/orderLineItemNotes';
import { SERVICE_RESPONSE_STATUS } from 'constants/common';
import * as errorOverlay from 'utils/errorOverlay';
import * as pageLevelPreloader from 'modules/page-level-preloader';

/**
 * @type {class}
 * @desc A React container/smart component to render a React presentational/dumb component (view).
 * @example
 * import { OrderLineItemNotes } from 'ui/containers/OrderLineItemNotes';
 *
 * // render
 * <OrderLineItemNotes propName='propValue'/>
 */
export class OrderLineItemNotes extends React.Component {
    
    /**
     * @param {object} props - props
     */
    constructor( props ) {
        super( props );

        this.state = {
            enableAdd: false
        };

        this.handleAddClick = this.handleAddClick.bind( this );
        this.handleSubmitClick = this.handleSubmitClick.bind( this );

        // member prescriptions instance
        this.orderLineItemNotesService = new OrderLineItemNotesService();
    }

    handleAddClick( val ) {
        log.debug( 'OrderLineItemNotes.handleAddClick()' );

        this.setState( {
            enableAdd: val
        } );
    }

    async handleSubmitClick( value ) {
        log.debug( 'OrderLineItemNotes.handleSubmitClick()' );

        pageLevelPreloader.show();

        // cancel ongoing request
        this.orderLineItemNotesService.cancel();

        const action = find( this.props.data.formActions, { name: 'save' } );

        const reqData =  merge(
            { ...this.props.requestPayload },
            {
                data: { note: get( value, 'description' ), type: get( value, 'type' ) }
            },
        );

        // fetch component data
        const { status } = await this.orderLineItemNotesService.submitAddNote( {
            url: get( action, 'url' ),
            data: reqData
        } );
        
        pageLevelPreloader.hide();

        // check if response status was success
        if( SERVICE_RESPONSE_STATUS.SUCCESS !== status ) {

            errorOverlay.open();
            
        } else {
            this.setState( {
                enableAdd: false
            } );
        }
    }

    componentWillUnmount() {
        log.debug( 'OrderLineItemNotes.componentWillUnmount()' );

        this.orderLineItemNotesService.cancel();
    }

    /**
     * @desc Render a React view component
     */
    render() {
        return (
            <CSrOrderListNotesView { ...this.props } { ...this.state } onAddClick={ this.handleAddClick } onSubmitClick={ this.handleSubmitClick } />
        );
    }
}

// set display name
OrderLineItemNotes.displayName = 'OrderLineItemNotes';

// set default props
OrderLineItemNotes.defaultProps = {};

// prop types
OrderLineItemNotes.propTypes = {};
